// Una riga di «cambio di hechsher».
//
// Stava dentro App.js. L'ho tirata fuori il 29/10/2026 perché Menachem ha
// chiesto gli aggiornamenti di kashrut anche sulla pagina News, e NewsPage.js
// è importata DA App.js: importare da lì avrebbe chiuso un anello fra i due
// file. Un file suo lo apre, e la riga resta una sola — se cambia il colore
// del «non più certificato» cambia in tutti e tre i posti che la usano
// (home, /kashrut-changes, /news).
import React from 'react';
import { buildPlaceUrl } from './slug';
import { t } from './i18n';

const COLORS = { primary: '#1a4d8f', text: '#1f2937', muted: '#6b7280', border: '#e5e7eb' };

export const CAMBIO = {
  lost: { segno: '⚠️', colore: '#b42318', testo: 'No longer certified' },
  gained: { segno: '✡️', colore: '#067647', testo: 'Now certified' },
  changed: { segno: '🔄', colore: '#b54708', testo: 'Hechsher changed' },
};

export default function KashrutChangeRow({ c, grande = false }) {
  const m = CAMBIO[c.kind] || CAMBIO.changed;
  const url = buildPlaceUrl(c) || `/place/${c.establishment_id}`;
  const quando = c.happened_at ? new Date(c.happened_at) : null;
  const vecchio = (c.old_supervision || '').trim();
  const nuovo = (c.new_supervision || '').trim();
  return (
    <a href={url}
       style={{ display: 'block', textDecoration: 'none', color: 'inherit', background: 'white',
         border: `1px solid ${COLORS.border}`, borderLeft: `4px solid ${m.colore}`, borderRadius: 10,
         padding: grande ? '14px 16px' : '10px 12px' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
        <span aria-hidden="true">{m.segno}</span>
        <span style={{ fontWeight: 700, color: m.colore, fontSize: grande ? 14 : 13 }}>{t(m.testo)}</span>
        {quando && (
          <span style={{ fontSize: 12, color: COLORS.muted, marginInlineStart: 'auto' }}>
            {quando.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}
          </span>
        )}
      </div>
      <div style={{ fontWeight: 700, color: COLORS.primary, fontSize: grande ? 16 : 14, marginTop: 3 }}>
        {c.name}
        {c.city ? <span style={{ fontWeight: 400, color: COLORS.muted }}> — {c.city}{c.country ? `, ${c.country}` : ''}</span> : null}
      </div>
      <div style={{ fontSize: 13, color: COLORS.text, marginTop: 4 }} dir="auto">
        {c.kind === 'lost' && vecchio ? `${t('Was')}: ${vecchio}` : null}
        {c.kind === 'gained' && nuovo ? `${t('Now')}: ${nuovo}` : null}
        {c.kind === 'changed' ? `${vecchio || t('none')} → ${nuovo || t('none')}` : null}
      </div>
      {c.note ? <div style={{ fontSize: 13, color: COLORS.muted, marginTop: 4 }} dir="auto">{c.note}</div> : null}
    </a>
  );
}
